import { Button } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { HOST_RETAGUARDA, useUrlSistema } from '../../lib/sistemas-sischef';

/** Tela única de integrações do Sischef Retaguarda — o card do Google Maps tem o botão da chave. */
const CAMINHO_INTEGRACOES = '/admin/pedido/integracao/integracoes.jsf';

/**
 * Leva o gestor até onde a chave do Google Maps é cadastrada.
 *
 * A chave não é (e não pode ser) informada no cardápio: ela mora na integração
 * da empresa no Sischef Retaguarda, junto com a que a roteirização usa. Sem
 * este atalho, a tela dizia onde configurar e deixava o gestor procurar o menu
 * — o caminho tem quatro níveis e vira chamado de suporte.
 *
 * Some se o endereço da retaguarda não puder ser resolvido: botão que não leva
 * a lugar nenhum é pior que botão nenhum.
 */
export function BotaoConfigurarGoogleMaps({
  variant = 'outlined',
}: {
  variant?: 'outlined' | 'contained' | 'text';
}): JSX.Element | null {
  const url = useUrlSistema(HOST_RETAGUARDA, CAMINHO_INTEGRACOES);
  if (!url) return null;

  return (
    <Button
      component="a"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      variant={variant}
      size="small"
      endIcon={<OpenInNewIcon />}
    >
      Configurar Google Maps
    </Button>
  );
}
